import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

export function atomWithDevStorage<Value>(key: string, initialValue: Value) {
  if (process.env.NODE_ENV === "development") {
    return atomWithStorage<Value>(key, initialValue, undefined, { getOnInit: true });
  } else return atom<Value>(initialValue);
}
